import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';
import { uploadsApi } from 'apis/uploads';

type RoutedThroughAnnouncementProps = {
  node: ConversationFlowAuditLogEntry<'ANNOUNCEMENT_NODE_VISITED'>;
};

export function RoutedThroughAnnouncement({
  node,
}: RoutedThroughAnnouncementProps): JSX.Element {
  const { data } = uploadsApi.useReadAnnouncementsQuery(undefined, {
    skip: !node.announcement,
  });

  const currentName = data?.data.uploads.find(
    ({ url }) => url === node.announcement,
  )?.pretty_name;

  return (
    <>
      Audio message · <strong>{currentName || node.label}</strong> is played
    </>
  );
}
